import Axios from 'axios'
import { isTraceabilityEnabled } from '@/utils/feature-toggle'

const rescheduleService = {
  axios () {
    let AxiosInstance = Axios
    AxiosInstance.defaults.baseURL = process.env.TRACEABILITY_BASE_URL
    return AxiosInstance
  },
  getRescheduledOrders (orderId) {
    return isTraceabilityEnabled()
      ? this.axios().get('/exams/reschedule', {
          params: {
            os: orderId
          }
        })
      : Promise.resolve({ data: [] })
  },
  getTotalRescheduledOrders () {
    return isTraceabilityEnabled()
      ? this.axios().get('/exams/reschedule/count')
      : Promise.resolve({ data: { rescheduledCount: 0 } })
  }
}

export default rescheduleService
